import { createFileRoute } from '@tanstack/react-router';

import { courtside } from '@/api/sideline';
import { SidelineReviewPage } from '@/components/sideline/SidelineReviewPage';

function Page() {
  return <SidelineReviewPage api={courtside} sport="basketball" />;
}

export const Route = createFileRoute('/custom/courtside-review')({
  component: Page
});
